import { makeStyles } from '@material-ui/styles'
import ActionPopOver from 'app/plugins/openstack/components/networks/dns/ActionPopover'
import { getDnsResourceStatus } from 'app/plugins/openstack/components/networks/dns/helper'
import { DnsPageTabs } from 'app/plugins/openstack/components/networks/dns/model'
import { DnsRecordType } from 'app/plugins/openstack/components/networks/dns/records/RecordTypePicklist'
import DeleteZoneDialog from 'app/plugins/openstack/components/networks/dns/zones/DeleteZoneDialog'
import { getFieldsForCard } from 'core/components/InfoPanel'
import Badge from 'core/elements/badge'
import IconButton from 'core/elements/button/IconButton'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import { routeManager } from 'core/utils/routes'
import { PropertiesTable } from 'k8s/components/kaapi/cluster-upgrade/PropertyCardTable'
import React, { useCallback, useMemo, useState } from 'react'
import { formatDate } from 'utils/misc'

const metadataFields = [
  { id: 'type', title: 'Zone Type' },
  { id: 'poolName', title: 'DNS Pool' },
  { id: 'email', title: 'Contact' },
  {
    id: 'ttl',
    title: 'Default TTL',
    render: (value) => <Text variant="caption1">{value}</Text>,
  },
  {
    id: 'created',
    title: 'Created',
    render: (value) => (value ? formatDate(value) : 'N/A'),
  },
]

const ZoneCard = ({ item }) => {
  const classes = useStyles()
  const url = new URL(window.location.href)
  const selectedView = url.searchParams.get('view')

  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)

  const metadata = useMemo(() => {
    return getFieldsForCard(metadataFields, item)
  }, [item])

  const status = useMemo(() => getDnsResourceStatus(item.status.status, item.status.action), [
    item.status,
  ])

  const handleClick = useCallback((event) => {
    setOpen(true)
    setAnchorEl(event.currentTarget)
  }, [])

  const isNsOrSoaType = item?.type === DnsRecordType.NS || item?.type === DnsRecordType.SOA

  return (
    <>
      {showDeleteDialog && (
        <DeleteZoneDialog rows={[item]} onClose={() => setShowDeleteDialog(false)} />
      )}
      <div className={classes.cardContainer}>
        <div className={classes.headerContainer}>
          <div>
            <Badge text={status.label} variant={status.variant} />
            <Text className={classes.nameText} variant="subtitle2">
              {item?.name}
            </Text>
          </div>
          <IconButton
            size="md"
            icon="ellipsis"
            solid={true}
            className={classes.settingsMenuButton}
            onClick={handleClick}
          />
        </div>
        <div className={classes.propertiesTable}>
          <PropertiesTable fields={metadata} />
        </div>
      </div>
      <ActionPopOver
        open={open}
        setOpen={setOpen}
        anchorEl={anchorEl}
        editRoute={routeManager.routes.openstack.editDnsResource.path({
          tab: DnsPageTabs.Zones,
          id: item?.id,
          view: selectedView,
        })}
        setShowDeleteDialog={setShowDeleteDialog}
        disableEditCond={isNsOrSoaType}
        disableDeleteCond={isNsOrSoaType}
      />
    </>
  )
}
export default ZoneCard

const useStyles = makeStyles<Theme>((theme) => ({
  cardContainer: {
    display: 'grid',
    gridTemplateRows: 'auto auto',
    width: '325px',
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
    padding: theme.spacing(3),
    gap: theme.spacing(3),
    background: theme.palette.common.white,
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  nameText: {
    marginTop: theme.spacing(2),
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.grey[200]}`,
    width: theme.spacing(4),
    height: theme.spacing(4),
    rotate: '90deg',
    '& i': {
      color: theme.palette.grey[500],
    },
    cursor: 'pointer',
  },
  propertiesTable: {
    '& .properties-table': {
      '& .property-row': {
        gridTemplateColumns: '85px 12px 1fr',
      },
    },
  },
  settingsMenuButton: {
    '& i': {
      rotate: '90deg',
    },
  },
  settingsMenuContainer: {
    padding: theme.spacing(1, 0),
    width: '154px',
  },
  settingsMenuItem: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    alignItems: 'center',
    gap: 6,
    padding: theme.spacing(1, 2),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
  },
}))
